const COLOR_CLASSES = ['bg-[#f5c451]', 'bg-[#7ed6b8]', 'bg-[#ff9aa2]', 'bg-[#a9c4ff]', 'bg-[#e2b6ff]', 'bg-[#ffd9a0]']

interface AvatarProps {
  name: string
  /** Index i spillerlisten - afgør farven, ligesom prototypens c0-c5. */
  index?: number
  /** 'lg' matcher prototypens større melder/makker-knapper (44px). */
  size?: 'default' | 'lg'
  className?: string
}

const SIZE_CLASSES: Record<'default' | 'lg', string> = {
  default: 'h-[calc(34px*var(--scale))] w-[calc(34px*var(--scale))] text-[0.85em]',
  lg: 'h-[calc(44px*var(--scale))] w-[calc(44px*var(--scale))] text-[1em]'
}

function Avatar({ name, index = 0, size = 'default', className = '' }: AvatarProps) {
  const colorClass = COLOR_CLASSES[((index % COLOR_CLASSES.length) + COLOR_CLASSES.length) % COLOR_CLASSES.length]
  return (
    <span
      className={`inline-grid flex-none place-items-center rounded-full font-extrabold text-ink ${SIZE_CLASSES[size]} ${colorClass} ${className}`}
    >
      {(name || '?').charAt(0).toUpperCase()}
    </span>
  )
}

export default Avatar
